/* eslint-disable no-param-reassign */
import baseAxios, {
  AxiosInstance,
  AxiosRequestConfig,
  isAxiosError,
} from 'axios';
import API_URL from '../apiconfig';
import { auth } from '../firebase';
import { socket } from '../constants/socket';

export const getCurrentUserAuthorization = async () => {
  const { currentUser } = auth;
  if (currentUser) {
    const token = await currentUser.getIdToken();
    return `Bearer ${token}`;
  }
  return '';
};

export const isAxiosRateLimitError = (error: any) =>
  isAxiosError(error) && error.response?.status === 429;

const axios: AxiosInstance = baseAxios.create({
  baseURL: API_URL,
  timeout: 1000 * 30,
  // Timeouts report ETIMEDOUT so ECONNABORTED only means a client abort
  transitional: { clarifyTimeoutError: true },
  headers: {
    'Content-Type': 'application/json',
  },
});

const onRequest = async (config: AxiosRequestConfig): Promise<any> => {
  const authorization = await getCurrentUserAuthorization();
  const businessId = localStorage.getItem('selectedBusiness');
  if (config.headers) {
    if (authorization) {
      config.headers.Authorization = authorization;
    }
    if (businessId) {
      config.headers['x-porter-business-id'] = businessId;
    }
    if (socket.id) {
      config.headers['x-porter-socket-id'] = socket.id;
    }
  }
  return config;
};

axios.interceptors.request.use(onRequest);

export type { AxiosResponse } from 'axios';
export { isAxiosError } from 'axios';

export default axios;
